import { GoogleMedia } from "./googlemedia.model";

export interface IPlaylist {
    id: string;
    name: string;
    programName: string;
    programShortName: string;
    sortIdx?: number;
    tracks?: Array<GoogleMedia>;
    offline?: boolean;
    isRelease?: boolean;
    offlineDate?: string;
    favourite?: boolean;
}

export class Playlist implements IPlaylist {
    public sortIdx = 0;
    public tracks = new Array<GoogleMedia>();
    public id = '';
    public offline = false;
    public isRelease = false;
    public offlineDate = '';
    public favourite = false;

    constructor(
        public name: string,
        public programName: string,
        public programShortName: string,
    ) { }
}
